import { useState } from "react";
import { HiOutlineKey } from "react-icons/hi2";
import { useUser } from "../../hooks";
import { FormButton } from "../../ui";
import { ByokKeyModal } from "./byok-key-modal";
import "./byok-key.scss";

/**
 * Status-aware entry point to the OpenRouter key popup. Renders nothing for
 * plans without the byok ability. The dot mirrors the key state the backend
 * reports: green = valid, red = invalid, yellow = no OpenRouter balance.
 */
export const ByokKeyButton = (): JSX.Element | null => {
  const { currentUser } = useUser();
  const [showModal, setShowModal] = useState(false);

  const byok = currentUser?.byok;
  if (!byok?.enabled) return null;

  let dot: "green" | "red" | "yellow" | "grey" = "grey";
  let label = "Connect Key";
  if (byok.has_key) {
    if (byok.status === "invalid") {
      dot = "red";
      label = "Key invalid";
    } else if (byok.status === "no_credits") {
      dot = "yellow";
      label = "No balance";
    } else {
      dot = "green";
      label = `Key ****${byok.key_last4 ?? ""}`;
    }
  }

  const statusIcon = byok.has_key ? (
    <span className={`byok-key-btn__dot byok-key-btn__dot--${dot}`} />
  ) : (
    <HiOutlineKey size={15} />
  );

  return (
    <>
      <FormButton
        className="byok-key-btn"
        theme="grey"
        icon={statusIcon}
        onClick={() => setShowModal(true)}
      >
        {label}
      </FormButton>
      <ByokKeyModal open={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};
